<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()&&showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="人员编号">
          <el-input size="mini" v-model="params.TeacherNumber" placeholder="请填写人员编号" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input size="mini" v-model="params.TeacherName" placeholder="请填写姓名" />
        </el-form-item>
        <el-form-item label="职务">
          <el-input size="mini" v-model="params.JobNames" placeholder="请填写职务名称" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TeacherNumber" label="人员编号" min-width="100" />
        <el-table-column prop="TeacherName" label="姓名" min-width="90" />
        <el-table-column prop="JobNames" label="职务" min-width="130" />
        <!-- <el-table-column prop="VerificationCode" label="验证码（4位数字）" min-width="150px" /> -->
        <el-table-column prop="PhoneNumber" label="手机号码" min-width="115" />
        <el-table-column prop="CreateTime" label="创建时间" min-width="100">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showColumn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/fa/teacher").default,
      params: {
        TeacherNumber: "",
        TeacherName: "",
        JobNames: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
  },
};
</script>